class NotFoundError extends Error {
    constructor(message) {
        super(message || 'Page not found');
        this.code = 'ENOENT';
        this.statusCode = 404;
    }
}

module.exports = {
    NotFoundError,
};
